module.exports = __webpack_public_path__ + "static/media/align.28009f50.svg";